import {
  DataGrid,
  GridPageChangeParams,
} from "@material-ui/data-grid";
import * as React from "react";
import { useHistory, useLocation } from "react-router";
import { searchTracks, SEARCH_PAGE_SIZE } from "../../sdk/search";
import { TrackIndexSchema } from "../../../../../services/search-admin/types/index-schema/track-index-schema";
import { Input, Toolbar, Typography } from "@material-ui/core";

export const TrackListPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [size, setSize] = React.useState(0);
  const [tracks, setTracks] = React.useState<TrackIndexSchema[]>([]);
  const [page, setPage] = React.useState<number>(0);
  const [query, setQuery] = React.useState<string>();

  const handlePageChange = (params: GridPageChangeParams) => {
    setPage(params.page);
    handleSearch(false);
  };

  const handleSearch = (resetPage: boolean = true) => {
    setLoading(true);
    if (resetPage) {
      setPage(0);
    }
    searchTracks(resetPage ? 0 : page, query)
      .then((data) => {
        setTracks(data.results);
        setSize(data.total || 0);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    searchTracks()
      .then((data) => {
        setTracks(data.results);
        setSize(data.total || 0);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section>
      <Toolbar variant="dense" style={{ marginTop: "20px" }}>
        <Typography variant="h4" style={{ flexGrow: 1 }}>
          Tracks
        </Typography>
        <Input
          placeholder="Lookup track by isrc, artists or title.."
          inputProps={{ "aria-label": "search" }}
          style={{ width: "500px" }}
          value={query}
          onChange={(ev) => setQuery(ev.target.value)}
          onKeyDown={(ev) => (ev.key === "Enter" ? handleSearch() : undefined)}
        />
      </Toolbar>
      <div style={{ display: "flex", height: "750px", marginTop: "20px" }}>
        <DataGrid
          rows={tracks}
          columns={[
            {
              field: "title",
              headerName: "Title",
              width: 400,
              renderCell: (params) => {
                const track = params.row as TrackIndexSchema;
                return (<Typography>{track.title}</Typography>);
              },
            },
            {
              field: "author",
              headerName: "Author",
              width: 400,
              renderCell: (params) => {
                const track = params.row as TrackIndexSchema;
                return(<Typography>{track.author || ''}</Typography>);
              },
            },
            {
              field: "created_at",
              headerName: "Created At",
              width: 200,
              renderCell: (params) => {
                const track = params.row as TrackIndexSchema;
                return(<Typography>{new Date(track.created_at || '').toDateString()}</Typography>);
              },
            },
            {
              field: "isrc",
              headerName: "ISRC",
              width: 200,
              renderCell: (params) => {
                const track = params.row as TrackIndexSchema;
                return(<Typography>{track.isrc || ''}</Typography>);
              },
            },
            {
              field: "products",
              headerName: "Products",
              width: 200,
              renderCell: (params) => {
                const track = params.row as TrackIndexSchema;
                return(<Typography>{track.products || ''}</Typography>);
              },
            }
          ]}
          pagination
          pageSize={SEARCH_PAGE_SIZE}
          rowCount={size}
          onPageChange={handlePageChange}
          page={page}
          paginationMode="server"
          loading={loading}
          onRowClick={(params, ev) => {
            console.log(params);
            const url = `releases/${params.row.releaseId}/track/${params.row.id}`;
            if (ev.ctrlKey || ev.metaKey) {
              window.open(url, '_blank')
            } else {
              history.push(url, location.state)
            }
          }}
        />
      </div>
    </section>
  );
};
